export const initialMessageState = {
  message: false,
  type: "warning",
  timeout: 6000,
  closable: true,
};

// type: [warning, success]
